<template>
  <div>
    <customerTemplate
      v-if="configPageList.length > 0"
      :from-type="3"
      :show-edit-content-button="false"
      :show-edit-components-button="false"
      :show-delete-components-button="false"
      :show-insert-components-button="false"
      :show-sort-components-button="false"
      :template-page="
        configPageList.find((f) => f.pageType === OwPageType.首页)
      "
    >
    </customerTemplate>
  </div>
</template>

<script setup>
// #region 引用
import { OwPageType } from '@/configs/enums/website';
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import customerTemplate from '../components/Template.vue';

// #endregion

// #region props/emit

// #endregion

// #region 变量/常量

const configInfo = ref({}); // 配置信息
const configPageList = ref([]); // 配置页面列表

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

onServerPrefetch(async () => {
  const ssrContext = useSSRContext();

  configInfo.value = ssrContext.initialState?.data?.current?.configInfo;
  configPageList.value = ssrContext.initialState?.data?.current?.configPageList;
  // SEO useHead 已移至 layout 组件统一处理
  // SEO useHead has been moved to layout component for unified handling
});

if (!import.meta.env.SSR) {
  // 客户端从initialState读取数据
  const ssrInitialState = useSSRInitialStateStore();
  configInfo.value = ssrInitialState.data.current.configInfo;
  configPageList.value = ssrInitialState.data.current.configPageList;
}

// #endregion
</script>
